<template>
  <v-dialog v-model="dialog" persistent scrollable1 @keydown.esc="dialog = false">
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-show="tabs.length" color="primary" dark v-bind="attrs" v-on="on">
        <v-badge color="green" :content="tabs.length" overlap>
          <v-icon>mdi-home-analytics </v-icon>
        </v-badge>
      </v-btn>
    </template>

    <v-card style="position: absolute; top: 10px; left: 10px; right: 10px; bottom: 10px; width: auto; margin: auto" height="auto">
      <v-card-title style="position: absolute; top: 0; left: 0; right: 0; border-bottom: 1px solid #ddd; display: block; white-space: nowrap; text-overflow: clip">
        <span style="overflow: hidden; padding-right: 36px; text-overflow: ellipsis; display: block"> Анализ графика работ на объектах</span>

        <v-btn style="position: absolute; right: 12px; top: 12px" fab dark small color="blue-grey" title="Закрыть окно" @click="dialog = false">
          <v-icon dark> mdi-close </v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text
        :class="{
          'py-1 px-1': $vuetify.breakpoint.smAndDown,
          'py-4 px-6': !$vuetify.breakpoint.smAndDown,
        }"
        :style="`position: absolute; top: 67px; bottom: 0px; left: 0; right: 0; overflow: auto; overflow-x: hidden`"
      >
        <v-tabs dense v-model="tab" background-color="primary" show-arrows center-active @change="changeTab(tab)">
          <v-tab v-for="(tab, i) in tabs" :key="i" :href="`#tab-${tab.name}`" class="mr-3">
            <v-icon @click.native.prevent.stop="doExport(tab)" class="mr-2">fas fa-file-excel</v-icon>
            {{ tab.name }}
            <v-icon @click.native.prevent.stop="delItem(tab)"> mdi-close </v-icon>
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab" class="transparent" style="min-height: 200px" touchless>
          <v-tab-item v-for="(tab, i) in tabs" :key="tab.id" :id="`tab-${tab.name}`" :data-name="`${tab.name} section`">
            <ObjectViewWorksGantt
              :ref="`gantt_${tab.id}`"
              :object_id="tab.id"
              :object_data="tab"
              :config="{ height: $root.windowSize.contentHeight - 60, taskList: true }"
            />
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { getAccess } from "@/components/mixings";

export default {
  mixins: [getAccess],
  components: {
    ObjectViewWorksGantt: () => import("@/views/views/objectsViewWorksGantt"),
  },
  props: {},
  data() {
    return {
      idItemShow: 0,
      docName: "",
      dialog: false,
      type: null,
      api: undefined,
      tabs: [],
      tab: null,
    };
  },
  computed: {},
  created() {},
  watch: {
    showDocument(v) {
      if (!v) {
        this.idItemShow = 0;
        this.docName = "";
        this.type = null;
        this.$emit("onClose");
      }
    },
  },
  methods: {
    itemShowClose() {},
    doExport(item) {
      const n = `gantt_${item.id}`;
      const g = this.$refs[n];
      if (!g) return;
      // console.log(this.$refs[n]);
      g[0].doExport();
    },
    addItem(item) {
      if (this.tabs.find((i) => i.id == item.id)) return;
      let t = this.tabs;
      t.push(item);
      this.tabs = [...t];
    },
    delItem(item) {
      let t = this.tabs.filter((i) => i.id !== item.id);
      this.tabs = [...t];
      if (!t.length) this.dialog = false;
    },
    changeTab() {},
  },
};
</script>
